export function formatFileSize(bytes) {
  if (bytes == null || Number.isNaN(bytes)) return ""

  const size = Math.abs(bytes)

  if (size >= 1048576) return `${(size / 1048576).toFixed(1)} MB`
  if (size >= 1024) return `${(size / 1024).toFixed(1)} KB`

  return `${size} B`
}
